<template>
  <div class="accessibility">
    <ul>
      <li><a href="#headerWrap">상단메뉴</a></li>
      <li><a href="#middleWrapM">본문</a></li>
      <li><a href="#footerWrap">하단내용</a></li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
